// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".panelHeader_L1PJS{font-size:20px;line-height:28px}@media only screen and (min-width:1264px){.panelHeader_L1PJS{font-size:18px;line-height:26px}}.arrow_CMTn7{margin:-1px 0 0 9px}.arrow_CMTn7 path{fill:var(--cp-primary_support)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelHeader": "panelHeader_L1PJS",
	"arrow": "arrow_CMTn7"
};
module.exports = ___CSS_LOADER_EXPORT___;
